export interface Kpis {
  devicesCount: number;
  pushOpenedCount: number;
}

export const KpiHeaders = ["devicesCount", "pushOpenedCount"] satisfies (keyof Kpis)[];
